export const LOGIN_REQUEST = "LOGIN_REQUEST"
export const LOGIN_SUCCESS = "LOGIN_SUCCESS"
export const LOGING_FALUIRE = "LOGING_FALUIRE"
export const UPDATE_USER = "UPDATE_USER"
